<template>
    <div class="success-container">
        <feedback-header :title="title"/>
        <img class="succ-img" src="@/assets/images/feedback/commit_succ.png">
        <div class="succ-content">
            <p class="content-title">提交成功</p>
            <p class="content-desc">您的反馈我们都会认真对待，</p>
            <p class="content-desc">感谢您对顺丰速运的支持！</p>
        </div>
        <button class="back-btn" @click="goBack">返回</button>
    </div>
</template>

<script>
    import FeedbackHeader from './feedback-header'

    export default {
        data() {
            return {
                title: this.$route.params.sourceTitle
            }
        },
        components: {
            FeedbackHeader
        },
        methods: {
            // 返回按钮
            goBack() {
                location.href = "/mobile/cn/sc/index.html"
            }
        }
    }
</script>

<style lang="scss" scoped>
    .success-container{
        padding: 0 0.2rem 0.4rem;
        text-align: center;
        .succ-img{
            width: 4.5rem;
            margin-top: 0.5rem;
        }
        .succ-content{
            font-size: 0.3rem;
            .content-title{
                font-size: 0.44rem;
                font-weight: bold;
                margin-bottom: 0.28rem;
            }
        }
        .back-btn{
            border: 0.03rem solid $red;
            width: 2.56rem;
            height: 0.96rem;
            background: $white;
            margin-top: 0.8rem;
            border-radius: 0.6rem;
            color: $red;
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/feedback/feedback-succeed.vue